var exports = {
  "kL": "xaee3c4fa--4d3ee1--container",
  "wm": "xaee3c4fa--4d3ee1--logo",
  "DD": "xaee3c4fa--4d3ee1--title",
  "h_": "xaee3c4fa--4d3ee1--description",
  "XI": "xaee3c4fa--4d3ee1--action",
  "_N": "xaee3c4fa--4d3ee1--inlist",
};

module.exports = exports;
